module.exports = __webpack_public_path__ + "img/content_info1.6a3054ac.jpg";